import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
import type { ComponentProps } from 'react';
import React, { useState } from 'react';
import { InputField } from './InputField';

type PasswordFieldProps = Omit<
  ComponentProps<typeof InputField>,
  'type' | 'icon'
>;

export const PasswordField = React.forwardRef<
  HTMLInputElement,
  PasswordFieldProps
>((props, ref) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const PasswordIcon = () => (
    <button
      type="button"
      onClick={togglePasswordVisibility}
      className="rounded-full p-1 text-gray-500 hover:text-primary-teal focus:outline-none focus:ring-2 focus:ring-primary-teal focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
      disabled={props.disabled}
      aria-label={showPassword ? 'パスワードを隠す' : 'パスワードを表示'}
    >
      {showPassword ? (
        <EyeSlashIcon className="size-4" />
      ) : (
        <EyeIcon className="size-4" />
      )}
    </button>
  );

  return (
    <InputField
      ref={ref}
      type={showPassword ? 'text' : 'password'}
      icon={<PasswordIcon />}
      {...props}
    />
  );
});

PasswordField.displayName = 'PasswordField';
